import { useMemo } from 'react';

import { CraftsmanPropertyHeader } from '../../../components/CraftsmanPropertyHeader/CraftsmanPropertyHeader.tsx';

export const useHeaderByID = () =>
  useMemo(
    () =>
      ({ id }: { id: string }) => <CraftsmanPropertyHeader propertyId={id} />,
    [],
  );
